module.exports = __webpack_public_path__ + "img/24.951a85d3.png";